var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "document-automation-request-manage" }, [
    _c(
      "div",
      { staticClass: "document-rows" },
      [
        _c(
          "b-row",
          [
            _vm.documents.length
              ? _vm._l(_vm.documents, function (document, index) {
                  return _c("automation-document-classification", {
                    key: index + document.classification,
                    attrs: { document: document, editing: _vm.editing },
                    on: {
                      "change-description": function ($event) {
                        return _vm.handleEditDescription(index, $event)
                      },
                      "delete-document": function ($event) {
                        return _vm.handleDeleteDocument(index)
                      },
                    },
                  })
                })
              : !_vm.editing
              ? _c("b-col", { attrs: { cols: "12" } }, [
                  _c("p", { staticClass: "cursive text-light-gray" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "automations.documentLevel.editToAddMoreDocuments"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.editing
              ? _c(
                  "b-col",
                  {
                    attrs: { xl: "4", lg: "6", md: "12", sm: "6", cols: "12" },
                  },
                  [
                    _c("document-classification-select-container", {
                      staticClass: "document-automation-select",
                      attrs: { id: _vm.automationId + "-document-select" },
                      on: { create: _vm.handleCreateClassification },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }